import React, { forwardRef } from 'react';
import { BaseInput, BaseInputProps } from "./BaseInput";
import { cx } from "@/utils/cx";

interface InputFieldProps extends Omit<BaseInputProps, 'onChange' | 'onBlur'> {
    name: string; // Must match schema key
    label: string;
    value?: string;
    onChange?: (val: string) => void;
    onBlur?: (val: string) => void;
    error?: string;
    required?: boolean;
}

export const InputField = forwardRef<HTMLInputElement, InputFieldProps>(({
    name,
    label,
    value,
    onChange,
    onBlur,
    error,
    required,
    className,
    ...props
}, ref) => {

    return (
        <div className="flex flex-col gap-2.5 w-full">
            <label htmlFor={name} className="text-base text-gray-90">
                {label}
                {/* {required && <span className={cx("ml-0.5", error  ? "text-error" : "text-gray-90")}>*</span>} */}
                {required && <span className="text-red-500 ml-1">*</span>}
            </label>

            <BaseInput
                ref={ref}
                id={name}
                name={name}
                value={value || ''}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange?.(e.target.value)}
                onBlur={(e: React.FocusEvent<HTMLInputElement>) => onBlur?.(e.target.value)}
                isError={!!error}
                className={className}
                {...props as any}
            />

            {error && (
                <p className="text-xs text-error-60 font-medium">{error}</p>
            )}
        </div>
    );
});


InputField.displayName = "InputField";